<template>
  <div class="setting-pwd">
    <div class="title">修改密码</div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
      <el-form-item class="reset-psw-content-item" prop="password">
        <div class="reset-psw-content-title" style="margin-top: 24px">原密码：</div>
        <el-input v-model="loginForm.password" size="small" show-password class="reset-psw-content-input" placeholder="请输入原密码"></el-input>
      </el-form-item>
      <el-form-item class="reset-psw-content-item" prop="newPassword">
        <div class="reset-psw-content-title">新密码：</div>
        <!-- 新密码必须包含大小写，且大于8位数 -->
        <el-input v-model="loginForm.newPassword" size="small" show-password class="reset-psw-content-input" placeholder="请输入新密码"></el-input>
        <!-- <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span> -->
      </el-form-item>
      <el-form-item class="reset-psw-content-item" prop="passwordRe">
        <div class="reset-psw-content-title">确认密码：</div>
        <el-input v-model="loginForm.passwordRe" size="small" show-password class="reset-psw-content-input" placeholder="请再次输入新密码"></el-input>
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      :disabled="!(loginForm.password && loginForm.newPassword && loginForm.passwordRe)"
      style="width: 60px"
      @click="sumbitPsw"
    >
      确定
    </el-button>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
export default {
  name: "SettingPwd",
  data() {
    const validatePassword = (rule, value, callback) => {
      const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
      if (!reg.test(value)) {
        callback(new Error("密码需包含字母大小写和数字，且不少于8位"))
      } else {
        callback()
      }
    }
    const validatePasswordRe = (rule, value, callback) => {
      if (value !== this.loginForm.newPassword) {
        callback(new Error("密码不一致"))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        newPassword: "",
        password: "",
        passwordRe: ""
      },
      loginRules: {
        newPassword: [{ required: true, trigger: "blur", validator: validatePassword }],
        passwordRe: [{ required: true, trigger: "blur", validator: validatePasswordRe }]
      }
    }
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    ...mapState("user", ["isFirstLogin"])
  },
  mounted() {
    if (this.isFirstLogin) {
      this.$message({
        message: "当您第一次登陆系统，需要进行重置默认密码",
        type: "warning",
        duration: 5000
      })
    }
  },
  methods: {
    ...mapActions("user", ["resetPassword"]),
    sumbitPsw() {
      if (this.loginForm.newPassword === this.loginForm.password) return this.$message.error("新密码和老密码不能相同！")
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        this.resetPassword(this.loginForm).then(res => {
          if (res.code === "0" && res.success) {
            this.$message({
              message: "密码修改成功",
              type: "success"
            })
            this.$emit("success")
            this.$store.dispatch("user/resetToken")
            this.$router.push("/login")
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-pwd {
  width: 100%;
  height: 100%;
  padding: 24px 0 0 24px;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
  }

  .reset-psw-content-title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    margin-top: 1px;
  }

  .reset-psw-content-input {
    width: 320px;
    border-radius: 4px 4px 4px 4px;
    margin-top: 12px;
  }
}
</style>
